import { render, staticRenderFns } from "./ServidoresSistemas.vue?vue&type=template&id=66d7137a&scoped=true"
import script from "./ServidoresSistemas.vue?vue&type=script&lang=js"
export * from "./ServidoresSistemas.vue?vue&type=script&lang=js"
import style0 from "./ServidoresSistemas.vue?vue&type=style&index=0&id=66d7137a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d7137a",
  null
  
)

export default component.exports